export const AlertCircleIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99984 6.66406V9.9974M9.99984 13.3307H10.0082M18.3332 9.9974C18.3332 14.5998 14.6022 18.3307 9.99984 18.3307C5.39746 18.3307 1.6665 14.5998 1.6665 9.9974C1.6665 5.39502 5.39746 1.66406 9.99984 1.66406C14.6022 1.66406 18.3332 5.39502 18.3332 9.9974Z"
      stroke={props?.color || '#B42318'}
      strokeWidth={props?.strokeWidth || '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
